import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/app.config';
import { Observable } from 'rxjs';

export interface ZoomLink {
  id: number;
  enabled: boolean;
  zoomApiLink: string,
  outputLanguage: string
}

@Injectable({
  providedIn: 'root'
})
export class EventZoomLinkService {

  constructor(private http: HttpClient) {
  }

  // event zoom link CRUD
  get token() {
    return localStorage.getItem('accessToken');
  };

  getZoomLinks(eventId): Observable<ZoomLink[]> {
    return this.http
      .get<ZoomLink[]>(config.httpURL + `/api/event/${eventId}/zoom-links`, { params: { token: this.token } });
  }

  updateZoomLink(zoomLink: ZoomLink): Observable<ZoomLink> {
    return this.http
      .post<ZoomLink>(config.httpURL + `/api/event/update-zoom-link/${zoomLink.id}`, zoomLink, { params: { token: this.token } });
  }

  createZoomLink(eventId, zoomLink: ZoomLink): Observable<ZoomLink> {
    return this.http
      .post<ZoomLink>(config.httpURL + `/api/event/${eventId}/create-zoom-link`, zoomLink, { params: { token: this.token } });
  }

  deleteZoomLink(zoomLinkId): Observable<ZoomLink> {
    return this.http
      .delete<ZoomLink>(config.httpURL + `/api/event/delete-zoom-link/${zoomLinkId}`, { params: { token: this.token } });
  }
}

